import {
  Snackbar,
  Alert,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  //   TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Button,
  //   Divider,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import usePageTitle from "app/pageTitle";

import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";
import DataTable from "theme/Tables/DataTable";
import axios from "axios.js";

function ShippingRateViewPage() {
  const pageTitle = "Shipping Fees";
  usePageTitle(pageTitle);
  const navigate = useNavigate();

  const { ref } = useParams();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [refreshPage, setRefreshPage] = useState(false);

  const [shippingRate, setShippingRate] = useState(null);
  const [shippingRateLocations, setShippingRateLocations] = useState([]);
  const [states, setStates] = useState([]);
  let currency = "";
  const [openCreateShippingRateOptionDialog, setOpenCreateShippingRateOptionDialog] =
    useState(false);
  const [openEditShippingRateOptionDialog, setOpenEditShippingRateOptionDialog] = useState(false);
  const [selectedState, setSelectedState] = useState(null);
  const [optionLocation, setOptionLocation] = useState(null);
  const [optionFee, setOptionFee] = useState(null);

  const [selectedLocationOption, setSelectedLocationOption] = useState(null);

  async function updateCollectionOptionStatus(reference) {
    setShowLoading(true);
    await axios
      .get(`/portal/shipping_rates/options/${reference}/status/update.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteCollectionOption(reference) {
    setShowLoading(true);
    await axios
      .get(`/portal/shipping_rates/options/${reference}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  const optionsTableColumns = [
    { Header: "State", accessor: "state", align: "left" },
    { Header: "Coverage Area", accessor: "location", align: "left" },
    { Header: "Fee", accessor: "fee", align: "left" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Actions", accessor: "actions", align: "right" },
    // { Header: "Added On", accessor: "created", align: "center" },
  ];

  const buildLocationRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        state: row.state,
        location: row.title,
        fee: `${currency}${(row.amount / 100).toLocaleString("en", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
        status: (
          <MDBox>
            <Icon color={row.status ? "success" : "error"}>
              {row.status ? "check_circle" : "cancel"}
            </Icon>
          </MDBox>
        ),
        actions: (
          <MDBox mt={1} variant="button">
            <MDButton
              size="small"
              variant="outlined"
              color="warning"
              iconOnly
              onClick={() => {
                setSelectedLocationOption(row.reference);
                setOptionLocation(row.title);
                setOptionFee(row.amount / 100);
                setOpenEditShippingRateOptionDialog(true);
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                edit
              </Icon>
            </MDButton>
            &nbsp;&nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="info"
              iconOnly
              onClick={() => {
                if (
                  window.confirm(`${row.status ? "Disable" : "Enable"} this coverage area?`) ===
                  true
                ) {
                  updateCollectionOptionStatus(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                {row.status ? "pause" : "play_arrow"}
              </Icon>
            </MDButton>
            &nbsp;&nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                if (window.confirm(`Delete?`) === true) {
                  deleteCollectionOption(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
        // created: row.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/shipping_rates/${ref}/fetch.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            // console.log(result.data.data);
            currency = result.data.data.currency.symbol;
            setShippingRate(result.data.data.shipping_rate);
            setStates(result.data.data.states);
            const rows = buildLocationRows(result.data.data.shipping_rate.options);
            setShippingRateLocations(rows);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function addLocation() {
    if (selectedState === null) {
      setSeverity("error");
      setErrMsg("State is required.");
      setOpen(true);
      return;
    }

    if (optionLocation === null) {
      setSeverity("error");
      setErrMsg("Location is required.");
      setOpen(true);
      return;
    }

    if (optionFee === null) {
      setSeverity("error");
      setErrMsg("Fee is required.");
      setOpen(true);
      return;
    }

    setOpenCreateShippingRateOptionDialog(false);
    setShowLoading(true);
    const json = {
      reference: shippingRate.reference,
      state: selectedState,
      title: optionLocation,
      fee: optionFee * 100,
    };

    await axios
      .post("portal/shipping_rates/options/add.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function editLocation() {
    if (optionLocation === null) {
      setSeverity("error");
      setErrMsg("Location is required.");
      setOpen(true);
      return;
    }

    if (optionFee === null) {
      setSeverity("error");
      setErrMsg("Fee is required.");
      setOpen(true);
      return;
    }

    setOpenEditShippingRateOptionDialog(false);
    setShowLoading(true);
    const json = {
      reference: selectedLocationOption,
      title: optionLocation,
      fee: optionFee * 100,
    };

    await axios
      .post("portal/shipping_rates/options/edit.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>

      <Dialog open={openCreateShippingRateOptionDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Add Coverage Area</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>State</InputLabel>
                <Select
                  value={selectedState}
                  label="State"
                  onChange={(e) => {
                    setSelectedState(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {
                    // --> Notice below changes
                    states.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      states.map((record) => (
                        <MenuItem value={record.reference}>{record.title}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
            <MDBox mt={3}>
              <MDInput
                value={optionLocation}
                name="location"
                multiline
                minRows={5}
                margin="dense"
                label="Coverage Area(s)"
                type="text"
                fullWidth
                variant="outlined"
                placeholder="Example: Lagos Island, Lagos Mainland, Lekki Phase 1, Ikeja Environs, Alimosho etc"
                helperText="An area, region or group of areas within the state."
                onChange={(e) => setOptionLocation(e.target.value)}
              />
            </MDBox>
            <MDBox mt={3}>
              <MDInput
                value={optionFee}
                name="fee"
                margin="dense"
                label="Shipping Fee"
                type="decimal"
                fullWidth
                variant="outlined"
                onChange={(e) => setOptionFee(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenCreateShippingRateOptionDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              addLocation();
            }}
          >
            Add
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog open={openEditShippingRateOptionDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Edit Area Coverage</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={3}>
              <MDInput
                value={optionLocation}
                name="location"
                multiline
                minRows={5}
                margin="dense"
                label="Coverage Area(s)"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setOptionLocation(e.target.value)}
              />
            </MDBox>
            <MDBox mt={3}>
              <MDInput
                value={optionFee}
                name="fee"
                margin="dense"
                label="Shipping Fee"
                type="decimal"
                fullWidth
                variant="outlined"
                onChange={(e) => setOptionFee(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenEditShippingRateOptionDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              editLocation();
            }}
          >
            Update
          </MDButton>
        </DialogActions>
      </Dialog>
      {shippingRate !== null ? (
        <MDBox>
          <MDBox mt={2}>
            <Button
              color="dark"
              startIcon={<Icon>west</Icon>}
              onClick={() => {
                navigate("/shipping-fees");
              }}
            >
              Back
            </Button>
          </MDBox>
          <MDBox pb={3} mt={2}>
            <Card sx={{ height: "100%", marginTop: "0px" }}>
              <MDBox>
                <MDBox p={2}>
                  <MDBox display="flex" justifyContent="space-between" alignItems="center">
                    <MDTypography variant="h6" fontWeight="light" textTransform="capitalize">
                      <b>
                        <small>Collection</small>
                      </b>
                      <br />
                      <span>{shippingRate.title}</span>
                    </MDTypography>
                    <MDBox display="flex" justifyContent="space-evenly" alignItems="end">
                      {/* <MDBox>
                      <MDButton
                        variant="contained"
                        color="dark"
                        iconOnly
                        onClick={() => {
                          setSelectedState(null);
                          setOptionLocation(null);
                          setOptionFee(null);
                          setOpenCreateShippingRateOptionDialog(true);
                        }}
                      >
                        <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                      </MDButton>
                    </MDBox> */}
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
          <MDBox mt={5}>
            <Card sx={{ height: "100%", marginTop: "0px" }}>
              <MDBox>
                <MDBox p={2}>
                  <MDBox display="flex" justifyContent="space-between" alignItems="center">
                    <MDTypography variant="h6" fontWeight="bold" textTransform="capitalize">
                      Coverage Areas
                    </MDTypography>
                    <MDBox display="flex" justifyContent="space-evenly" alignItems="end">
                      <MDBox>
                        <MDButton
                          variant="contained"
                          color="dark"
                          size="small"
                          iconOnly
                          onClick={() => {
                            setSelectedState(null);
                            setOptionLocation(null);
                            setOptionFee(null);
                            setOpenCreateShippingRateOptionDialog(true);
                          }}
                        >
                          <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDBox>
                <MDBox p={2}>
                  <DataTable
                    table={{ columns: optionsTableColumns, rows: shippingRateLocations }}
                    isSorted
                    entriesPerPage
                    showTotalEntries
                    buttons
                    noEndBorder
                  />
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
        </MDBox>
      ) : (
        <> </>
      )}

      <Footer />
    </DashboardLayout>
  );
}

export default ShippingRateViewPage;
